<section class="container mb-0 mt-1 mt-sm-3 mt-5 py-md-5 py-0">
    <div class="row">
        <h1
            class="text-start text-md-center mb-4 fw-normal"
            [innerHTML]="'tiles-info-header' | cmsText | async"
        ></h1>
        <ng-container *ngFor="let item of infoBullets">
            <div class="col-md-4 mt-2 mt-sm-5 mb-2 my-md-0">
                <div class="card p-4 link-box bullet-info h-100">
                    <a
                        [routerLink]="
                            'hero-bullet-' + item.id + '-routerlink'
                                | cmsText
                                | async
                        "
                        id="{{ 'moreInfo-bullet-' + item.id }}"
                    >
                        <div
                            class="col-2 col-md-6 col-xl-5 mx-sm-auto card-icon"
                        >
                            <img
                                class="img-fluid p-xl-2"
                                [attr.src]="
                                    'hero-bullet-' + item.id + '-img'
                                        | cmsImageSrc
                                        | async
                                "
                                [attr.alt]="
                                    'hero-bullet-' + item.id + '-img'
                                        | cmsImageAlt
                                        | async
                                "
                            />
                        </div>
                        <div class="pt-2">
                            <h3
                                class="card-title h6 fw-bold text-sm-center"
                                [innerHTML]="
                                    'hero-bullet-' + item.id + '-title'
                                        | cmsText
                                        | async
                                "
                            ></h3>
                            <p
                                class="card-text text-sm-center"
                                [innerHTML]="
                                    'hero-bullet-' + item.id + '-text'
                                        | cmsText
                                        | async
                                "
                            ></p>
                        </div>
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
</section>
